module.exports = __webpack_public_path__ + "img/sochi-new-wb-2024.dd7acc11.svg";